import React, { useState } from "react";
import Headroom from "react-headroom";
import { motion } from "framer-motion";
import { HiMenuAlt4, HiX } from "react-icons/hi";

import { ToggleButton } from "../../container";
import "./Navbar.scss";

const Navbar = () => {
  const [toggle, setToggle] = useState(false);

  return (
    <Headroom
      disableInlineStyles
      style={{
        WebkitTransition: "all .5s ease-in-out",
        MozTransition: "all .5s ease-in-out",
        OTransition: "all .5s ease-in-out",
        transition: "all .5s ease-in-out",
      }}
      className="dark:bg-darktheme"
    >
      <nav className="app__navbar font-codePro dark_nav transition-all">
        <div className="app__navbar-logo">
          <a
            href="/"
            className="block no-underline mt-[10px] leading-normal text-lg sm:text-brandSize"
          >
            <span className="dark_entities"> &#xFF5B;&lt;</span>
            <span className="nav-logo-name text-transparent bg-clip-text bg-blue-900 dark:text-slate-50">
              HmdDev
            </span>
            <span className="dark_entities"> /&gt;&#xFF5D;</span>
          </a>
        </div>
        <ul className="app__navbar-links">
          {["home", "about", "work", "skills", "testimonial", "contact"].map(
            (item) => (
              <li className="app__flex group" key={`link-${item}`}>
                <div className="dark:group-hover:bg-slate-300" />
                <a
                  className="text-[#6b7688] dark:text-slate-300 dark:hover:text-slate-50 dark:after:bg-slate-50"
                  href={`#${item}`}
                >
                  {item}
                </a>
              </li>
            )
          )}
        </ul>
        <ul className="py-2 px-3 rounded-lg hover:bg-gray-200 dark:hover:bg-[#161d27] transition-all">
          <ToggleButton />
        </ul>

        {/* Mobile Navigation Menu */}
        <div className="app__navbar-menu">
          <HiMenuAlt4
            onClick={() => setToggle(true)}
            className="cursor-pointer"
          />

          {toggle && (
            <motion.div
              whileInView={{ x: [300, 0] }}
              transition={{ duration: 0.85, ease: "easeInOut" }}
              className="dark:bg-darktheme dark:transition-all relative dark:bg-none"
            >
              <HiX
                onClick={() => setToggle(false)}
                className="cursor-pointer text-white"
              />

              <ul>
                {[
                  "home",
                  "about",
                  "work",
                  "skills",
                  "testimonial",
                  "contact",
                ].map((item) => (
                  <li key={item}>
                    <a
                      className="dark:text-slate-300 relative dark:hover:bg-darkthemealt dark:hover:text-slate-50 dark:py-2 px-4  rounded-md "
                      href={`#${item}`}
                      onClick={() => setToggle(false)}
                    >
                      {item}
                    </a>
                  </li>
                ))}
              </ul>
            </motion.div>
          )}
        </div>
      </nav>
    </Headroom>
  );
};

export default Navbar;
